import React from "react";

import PostInterActionStyles from "./PostInterActionStyles.module.css";

import { usePostForm } from "../../../context/PostFormContext";

type Props = {
  fileInputRef?: React.RefObject<HTMLInputElement>;
};

const PostInterActionBlk = ({ fileInputRef: externalRef }: Props) => {
  const internalRef = React.useRef<HTMLInputElement>(null);
  const fileInputRef = (externalRef ??
    internalRef) as React.RefObject<HTMLInputElement>;
  const { formPost, setFormPost, setMessage } = usePostForm();

  const handleImageClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const validTypes = [
      "image/png",
      "image/jpeg",
      "image/jpg",
      "image/svg+xml",
    ];
    const selectedFiles = Array.from(files);
    const invalidFiles = selectedFiles.filter(
      (file) => !validTypes.includes(file.type),
    );

    if (invalidFiles.length > 0) {
      setMessage("Only PNG, JPG, JPEG, or SVG files allowed.");
      e.target.value = "";
      return;
    }

    const currentImages = formPost.imagePost || [];
    const totalImages = currentImages.length + selectedFiles.length;

    if (totalImages > 6) {
      setMessage("You can upload a maximum of 6 images");
      e.target.value = "";
      return;
    }

    setFormPost({
      ...formPost,
      imagePost: [...currentImages, ...selectedFiles],
    });
  };

  return (
    <div>
      <div className={PostInterActionStyles.postIconBlk}>
        <i className="fa-regular fa-face-smile" />
        <span>GIF</span>

        <label
          htmlFor="imagePostUpload"
          aria-label="Upload images"
          style={{ cursor: "pointer" }}
        >
          <i
            className="fa-regular fa-image"
            style={{ cursor: "pointer" }}
            onClick={handleImageClick}
          />
        </label>
        <input
          type="file"
          name="imagePost"
          accept=".png,.jpg,.jpeg,.svg"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
          multiple
        />
      </div>
    </div>
  );
};

export default PostInterActionBlk;
